import {
  Box,
  Flex,
  Text,
  Menu,
  Portal,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { colors } from "../../theme";
import { logoutUser } from "../../redux/reducer/userSlice";
import { logoutAdmin } from "../../services/apiCalls";
import {
  ChevronDownIcon,
  LogoutIcon,
  SettingsIcon,
} from "../../utils/svg";
import { SIDEBAR_WIDTH } from "../Sidebar";

const Topbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginUser } = useSelector((state) => state.user);

  // End the session on the server too, so the old token stops working.
  const handleLogout = async () => {
    try {
      await logoutAdmin();
    } catch (e) {
      // sign out locally regardless
    }
    localStorage.removeItem("token");
    dispatch(logoutUser());
    navigate("/login");
  };

  return (
    <Box
      as="header"
       borderRadius={16}
      left={SIDEBAR_WIDTH}
      right={0}
      h="70px"
      bg="white"
      borderBottom="1px solid"
      borderColor={colors.disabled}
     
    
      px={6}
    >
      <Flex h="100%" align="center" justify="flex-end">
        {/* Account menu (the search box and bell that were here did nothing) */}
        <Flex align="center" gap={4}>
          {/* User Profile Dropdown */}
          <Menu.Root>
            <Menu.Trigger asChild>
              <Flex
                as="button"
                align="center"
                gap={3}
                px={3}
                py={2}
                borderRadius="md"
                _hover={{ bg: colors.background }}
                transition="all 0.2s"
              >
                {/* Avatar */}
                <Box
                  w={10}
                  h={10}
                  borderRadius="full"
                  bg={colors.primary}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color="white"
                  fontWeight="bold"
                  fontSize="sm"
                >
                  {loginUser?.name?.charAt(0)?.toUpperCase() || "A"}
                </Box>
                <Box textAlign="left">
                  <Text fontSize="sm" fontWeight="600" color={colors.text}>
                    {loginUser?.name || "Admin User"}
                  </Text>
                  <Text fontSize="xs" color={colors.textSecondary}>
                   {loginUser?.role}
                  </Text>
                </Box>
                <ChevronDownIcon boxSize={4} color={colors.textSecondary} />
              </Flex>
            </Menu.Trigger>

            <Portal>
              <Menu.Positioner>
                <Menu.Content
                  bg="white"
                  borderRadius="md"
                  boxShadow="lg"
                  py={2}
                  minW="180px"
                  border="1px solid"
                  borderColor={colors.disabled}
                >
                  <Menu.Item
                    value="settings"
                    px={4}
                    py={2}
                    fontSize="sm"
                    cursor="pointer"
                    _hover={{ bg: colors.background }}
                    onClick={() => navigate("/settings")}
                  >
                    <Flex align="center" gap={3}>
                      <SettingsIcon boxSize={4} />
                      <Text>Settings</Text>
                    </Flex>
                  </Menu.Item>
                  <Menu.Separator my={1} borderColor={colors.disabled} />
                  <Menu.Item
                    value="logout"
                    px={4}
                    py={2}
                    fontSize="sm"
                    cursor="pointer"
                    color="#EF4444"
                    _hover={{ bg: "rgba(239, 68, 68, 0.1)" }}
                    onClick={handleLogout}
                  >
                    <Flex align="center" gap={3}>
                      <LogoutIcon boxSize={4} />
                      <Text>Logout</Text>
                    </Flex>
                  </Menu.Item>
                </Menu.Content>
              </Menu.Positioner>
            </Portal>
          </Menu.Root>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Topbar;
